import React from 'react'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Table, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input } from 'reactstrap'
import axios from '../utils/posAxios'
import StorageService from '../services/StorageService'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import moment from 'moment-timezone'
import { MDBDataTableV5, MDBIcon } from 'mdbreact'
import '@fortawesome/fontawesome-free/css/all.min.css'
import classnames from 'classnames'

class FollowUpOrder extends React.Component {
  _isMounted = true
  constructor(props) {
    super(props)
    this.state = {
      isLoading: true,
      orderList: [],
    }
  }

  componentDidMount() {
    this.getOrder()
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  getOrder() {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.props.state.store_id,
      limit: 100,
    }

    axios
      .post(url + ':3003/v1/order/followup', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          for (let i of result.data) {
            if (i.order_dt) {
              i.order_dt = moment(i.order_dt).tz('Asia/Singapore').format('YYYY-MM-DD')
            }
            if (i.invoice_no === null) {
              i.invoice_no = ''
            }
            if (i.total_tax) {
              i.total_tax = parseFloat(i.total_tax).toFixed(2)
            }
            i.Action = (
              <div className="ps-action-button">
                <Button className="theme-button theme-button-secondary" onClick={() => this.props.order(i.order_id)}>
                  View
                </Button>
              </div>
            )
          }

          this.setState({
            isLoading: false,
            orderList: result.data,
            // filterList:
            //   this.state.status === 'Process' && this.state.state != 'Default'
            //     ? result.data.filter(x => x.order_status == this.state.state)
            //     : result.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  render() {
    const data = {
      columns: this.props.tbcolumn,
      rows: this.state.orderList,
    }
    return (
      <>
        <MDBDataTableV5 className="ps-order-table th-11" data={data} displayEntries={false} searchTop searchBottom={false} noRecordsFoundLabel="No data to show" fullPagination disableRetreatAfterSorting={true} responsive />
      </>
    )
  }
}

export default FollowUpOrder
